export default {
  methods: {
    doFixedTabBoxTabs() {
      let { y } = this.$refs['tabBox'].getBoundingClientRect();
      if ( y < 0 ) {
        this.$refs['main'].classList.add('fix-tabs')
      } else {
        this.$refs['main'].classList.remove('fix-tabs')
      }
    },
    screenToTop () {
      if (this.$refs['main']) {
        this.$refs['main'].classList.remove('fix-tabs');
        this.$refs['main'].scrollTop = 0;
      }
    }
  },
  watch: {
    active() {
      this.screenToTop();
    },
    activeTab() {
      this.screenToTop();
    },
  },
  created () {
    this.$nextTick(()=>{
      this.$refs['main'] && this.$refs['main'].addEventListener('scroll', (e)=>{
        if (this.$refs['tabBox']) {
          this.doFixedTabBoxTabs();
        }
      })
    })
  }
}